export const EVENT_CHECK_AUTH = 'check-auth';

export const EVENT_REFRESH_PAGE = 'refresh-page';
export const EVENT_CHANGE_CONNECTED_TO_ROOM = 'change-connected-to-room';
export const EVENT_REFETCH = 'refetch';
export const EVENT_ENTER_SCREEN = 'enter-screen';
export const EVENT_SOCKET_ADMIN_UPDATE = 'socket-admin-update';
export const EVENT_MAINTENANCE = 'maintenance';

export const EVENT_READ_ALL_NOTIFICATION = 'read-all-notification';
export const EVENT_READ_NOTIFICATION = 'read-notification';
export const EVENT_HANDSHAKE = 'handshake';
export const EVENT_NEW_NOTIFICATION = 'new-notification';
